import { getMaxLabelWidth } from '../../util/label';
import { getAngleByMatrix } from '../../util/matrix';
import { near } from '../../util/util';
// ææ¬æ¯å¦æè½¬
function isRotate(label) {
    var matrix = label.attr('matrix');
    return matrix && matrix[0] !== 1; // ä»å¨è¿ä¸ªåºæ¯ä¸å¤å®
}
function getRotateAngle(label) {
    var angle = isRotate(label) ? getAngleByMatrix(label.attr('matrix')) : 0;
    return angle % 360;
}
// autohide ä¸åèèè¶åºéå¶
// function isOutLimit(isVertical: boolean, label: IElement, limitLength: number) {
//   if (!limitLength) {
//     // å¦ææ²¡éå¶ limitLength åç´æ¥è¿å false
//     return false;
//   }
//   const canvasBBox = label.getCanvasBBox();
//   let isOut = false;
//   if (isVertical) {
//     isOut = canvasBBox.width > limitLength;
//   } else {
//     isOut = canvasBBox.height > limitLength;
//   }
//   return isOut;
// }
// æ¯å¦éå 
function isOverlap(isVertical, first, second, minGap) {
    var overlap = false;
    var angle = getRotateAngle(first);
    var distance = isVertical
        ? Math.abs(second.attr('y') - first.attr('y'))
        : Math.abs(second.attr('x') - first.attr('x'));
    var prevBBox = (isVertical
        ? second.attr('y') > first.attr('y')
        : second.attr('x') > first.attr('x'))
        ? first.getBBox()
        : second.getBBox();
    if (isVertical) {
        var ratio = Math.abs(Math.cos(angle));
        if (near(ratio, 0, Math.PI / 180)) {
            overlap = prevBBox.width + minGap > distance;
        }
        else {
            overlap = prevBBox.height / ratio + minGap > distance;
        }
    }
    else {
        var ratio = Math.abs(Math.sin(angle));
        if (near(ratio, 0, Math.PI / 180)) {
            overlap = prevBBox.width + minGap > distance;
        }
        else {
            overlap = prevBBox.height / ratio + minGap > distance;
        }
    }
    return overlap;
}
// ä¿çç¬¬ä¸ä¸ªæèæåä¸ä¸ª
function reserveOne(isVertical, labelsGroup, reversed, autoHideCfg) {
    var minGap = (autoHideCfg === null || autoHideCfg === void 0 ? void 0 : autoHideCfg.minGap) || 0;
    var labels = labelsGroup
        .getChildren()
        .slice() // å¤å¶æ°ç»
        .filter(function (item) { return item.get('visible'); });
    if (!labels.length) {
        return false;
    }
    var hasHide = false;
    if (reversed) {
        // ç¿»è½¬
        labels.reverse();
    }
    var count = labels.length;
    var first = labels[0];
    var prev = first;
    for (var i = 1; i < count; i++) {
        var label = labels[i];
        var curBBox = label.getBBox();
        // ä¸åèèè¶åºéå¶ï¼èä»ä»æ ¹æ®æ¯å¦éå è¿è¡éè isOutLimit(isVertical, label, limitLength) ||
        var isHide = isOverlap(isVertical, prev, label, minGap);
        if (isHide) {
            label.hide();
            hasHide = true;
        }
        else {
            prev = label;
        }
    }
    return hasHide;
}
// ååæ½æ ·éèæ ç­¾ï¼æ³¨æè¿éåè®¾ label/tick æ¯ååç
function parityHide(isVertical, labelsGroup, autoHideCfg) {
    var minGap = (autoHideCfg === null || autoHideCfg === void 0 ? void 0 : autoHideCfg.minGap) || 0;
    var labels = labelsGroup.getChildren().slice(); // å¤å¶æ°ç»
    if (labels.length < 2) {
        // å¦ææ°éå°äº 2 åç´æ¥è¿åï¼ç­äº 2 æ¶å¯è½ä¹ä¼éå
        return false;
    }
    var hasHide = false;
    var first = labels[0];
    var firstBBox = first.getBBox();
    var second = labels[1];
    var count = labels.length;
    var angle = getRotateAngle(first);
    var distance = isVertical
        ? Math.abs(second.attr('y') - first.attr('y'))
        : Math.abs(second.attr('x') - first.attr('x'));
    var interval = 0; // ä¸éå çåæ ææ¬é´è·ä¸ªæ°
    if (isVertical) {
        // åç´çåæ è½´è®¡ç®åç´æ¹åçé´è·
        var ratio = Math.abs(Math.cos(angle));
        if (near(ratio, 0, Math.PI / 180)) {
            var maxWidth = getMaxLabelWidth(labels);
            interval = (maxWidth + minGap) / distance;
        }
        else {
            interval = (firstBBox.height / ratio + minGap) / distance;
        }
    }
    else {
        // æ°´å¹³åæ è½´
        var ratio = Math.abs(Math.sin(angle));
        if (near(ratio, 0, Math.PI / 180)) {
            var maxWidth = getMaxLabelWidth(labels);
            interval = (maxWidth + minGap) / distance;
        }
        else {
            interval = (firstBBox.height / ratio + minGap) / distance;
        }
    }
    // interval > 1 æ¶éè¦å¯¹ label è¿è¡éè
    if (interval > 1) {
        interval = Math.ceil(interval);
        for (var i = 0; i < count; i++) {
            if (i % interval !== 0) {
                // ä»ä¿çè¢«æ´é¤ç label
                labels[i].hide();
                hasHide = true;
            }
        }
    }
    return hasHide;
}
export function getDefault() {
    return equidistance;
}
/**
 * ä¿è¯é¦ä¸ª label å¯è§ï¼å³ä½¿è¶è¿ limitLength ä¹ä¸éè
 * @param {boolean} isVertical  æ¯å¦åç´
 * @param {IGroup}  labelsGroup label çåç»
 * @param {number} limitLength å¦ä¸ä¸ªæ¹åçé¿åº¦éå¶ï¼autoHide ä¸å³å¿
 * @param {AxisLabelAutoHideCfg} autoHideCfg autoHide overlap çå¯ééç½®åæ°
 */
export function reserveFirst(isVertical, labelsGroup, limitLength, autoHideCfg) {
    return reserveOne(isVertical, labelsGroup, false, autoHideCfg);
}
/**
 * ä¿è¯æåä¸ä¸ª label å¯è§ï¼å³ä½¿è¶è¿ limitLength ä¹ä¸éè
 * @param {boolean} isVertical  æ¯å¦åç´
 * @param {IGroup}  labelsGroup label çåç»
 * @param {number} limitLength å¦ä¸ä¸ªæ¹åçé¿åº¦éå¶ï¼autoHide ä¸å³å¿
 * @param {AxisLabelAutoHideCfg} autoHideCfg autoHide overlap çå¯ééç½®åæ°
 */
export function reserveLast(isVertical, labelsGroup, limitLength, autoHideCfg) {
    return reserveOne(isVertical, labelsGroup, true, autoHideCfg);
}
/**
 * ä¿è¯ç¬¬ä¸ä¸ªæåä¸ä¸ª label å¯è§ï¼å³ä½¿è¶è¿ limitLength ä¹ä¸éè
 * @param {boolean} isVertical  æ¯å¦åç´
 * @param {IGroup}  labelsGroup label çåç»
 * @param {number} limitLength å¦ä¸ä¸ªæ¹åçé¿åº¦éå¶ï¼autoHide ä¸å³å¿
 * @param {AxisLabelAutoHideCfg} autoHideCfg autoHide overlap çå¯ééç½®åæ°
 */
export function reserveBoth(isVertical, labelsGroup, limitLength, autoHideCfg) {
    var minGap = (autoHideCfg === null || autoHideCfg === void 0 ? void 0 : autoHideCfg.minGap) || 0;
    var labels = labelsGroup.getChildren().slice(); // å¤å¶æ°ç»
    if (labels.length <= 2) {
        // å¦ææ°éå°äºæç­äº 2 åç´æ¥è¿å
        return false;
    }
    var hasHide = false;
    var count = labels.length;
    var first = labels[0];
    var last = labels[count - 1];
    var preLabel = first;
    // æç§åä¿å­ç¬¬ä¸ä¸ªçé»è¾å¾ªç¯ä¸éï¼æåä¸ä¸ªä¸åä¸å¾ªç¯
    for (var i = 1; i < count - 1; i++) {
        var label = labels[i];
        var curBBox = label.getBBox();
        // åºå¼ isOutLimit(isVertical, label, limitLength) ||
        var isHide = isOverlap(isVertical, preLabel, label, minGap);
        if (isHide) {
            label.hide();
            hasHide = true;
        }
        else {
            preLabel = label;
        }
    }
    var overlap = isOverlap(isVertical, preLabel, last, minGap);
    if (overlap) {
        // åçå²çªï¼åéèåä¸ä¸ªä¿çåä¸ä¸ª
        preLabel.hide();
        hasHide = true;
    }
    return hasHide;
}
/**
 * ä¿è¯ label ååæ¾ç¤º å ä¸åºç°éå ï¼ä¸»è¦è§£å³ææ¬å±å çé®é¢ï¼å¯¹äº limitLength ä¸å¤ç
 * @param {boolean} isVertical  æ¯å¦åç´
 * @param {IGroup}  labelsGroup label çåç»
 * @param {number} limitLength å¦ä¸ä¸ªæ¹åçé¿åº¦éå¶ï¼autoHide ä¸å³å¿
 * @param {AxisLabelAutoHideCfg} autoHideCfg autoHide overlap çå¯ééç½®åæ°
 */
export function equidistance(isVertical, labelsGroup, limitLength, autoHideCfg) {
    var hasHide = parityHide(isVertical, labelsGroup, autoHideCfg);
    // å¤ç  timeCat ç±»åç tickï¼å¨ååçåºç¡ä¸ï¼åæ¬¡æ£æ¥åºç°éå çè¿è¡éè
    if (reserveOne(isVertical, labelsGroup, false)) {
        hasHide = true;
    }
    return hasHide;
}
/**
 * å equidistanceï¼ é¦åä¼ä¿è¯ labels ååæ¾ç¤ºï¼ç¶åä¼ä¿çé¦å°¾
 * @param isVertical
 * @param labelsGroup
 * @param {number} limitLength å¦ä¸ä¸ªæ¹åçé¿åº¦éå¶ï¼autoHide ä¸å³å¿
 * @param {AxisLabelAutoHideCfg} autoHideCfg autoHide overlap çå¯ééç½®åæ°
 */
export function equidistanceWithReverseBoth(isVertical, labelsGroup, limitLength, autoHideCfg) {
    var labels = labelsGroup.getChildren().slice(); // å¤å¶æ°ç»
    var hasHide = parityHide(isVertical, labelsGroup, autoHideCfg);
    if (labels.length > 2) {
        var first = labels[0];
        var last = labels[labels.length - 1];
        // å¦æç¬¬ä¸ä¸ªè¢«éèäº
        if (!first.get('visible')) {
            first.show();
            if (reserveOne(isVertical, labelsGroup, false, autoHideCfg)) {
                hasHide = true;
            }
        }
        // å¦ææåä¸ä¸ªè¢«éèäº
        if (!last.get('visible')) {
            last.show();
            if (reserveOne(isVertical, labelsGroup, true, autoHideCfg)) {
                hasHide = true;
            }
        }
    }
    return hasHide;
}
//# sourceMappingURL=auto-hide.js.map